import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { HiOutlinePhotograph } from "react-icons/hi";
import ImageWithAspectRatio from "../../common/ImagewithAspectRatio";
import { _imagesURL } from "../../../constants/API";
import "./postMedia.css";

export default function PostMediaGallery({
  media = [],
  sizes = 1.33,
  type = "image",
  isModal = false,
  initialIndex = 0,
  onImageClick,
}) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  if (!media || media.length === 0) return null;

  // Single Item in Modal
  if (isModal && media.length === 1) {
    const item = media[0];
    return (
      <div className="post-media-gallery post-media-gallery--modal">
        <div className="pdm-carousel-slide">
          {type === "video" ? (
            <video
              src={_imagesURL + item}
              controls
              autoPlay
              controlsList="nodownload"
            />
          ) : (
            <img
              src={_imagesURL + item}
              alt="Medical presentation"
            />
          )}
        </div>
      </div>
    );
  }

  // Exact height ratio as original: 555 / sizes
  const postHeight = 555 / sizes;

  return (
    <div
      className={`post-media-gallery ${
        isModal ? "post-media-gallery--modal" : ""
      }`}
    >
      {/* Floating Glass Image Counter Badge */}
      <div className="post-media-counter">
        <HiOutlinePhotograph size={13} style={{ flexShrink: 0 }} />
        <span>
          {currentIndex + 1} / {media.length}
        </span>
      </div>

      <Carousel
        selectedItem={currentIndex}
        onChange={(index) => setCurrentIndex(index)}
        autoPlay={false}
        infiniteLoop={false}
        showIndicators={false}
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        emulateTouch={true}
        swipeable={true}
      >
        {media.map((item, index) => (
          <div
            key={index}
            onClick={() => onImageClick && onImageClick(index)}
            className={isModal ? "pdm-carousel-slide" : ""}
          >
            {isModal ? (
              type === "video" ? (
                <video
                  src={_imagesURL + item}
                  controls
                  autoPlay={currentIndex === index}
                  controlsList="nodownload"
                />
              ) : (
                <img
                  src={_imagesURL + item}
                  alt={`Medical presentation slide ${index + 1}`}
                />
              )
            ) : (
              <ImageWithAspectRatio
                height={postHeight}
                src={_imagesURL + item}
                alt={`Medical post slide ${index + 1}`}
              />
            )}
          </div>
        ))}
      </Carousel>

      {/* Floating Glass Prev Chevron */}
      {currentIndex > 0 && (
        <button
          type="button"
          className="post-media-nav-btn post-media-nav-btn--prev"
          onClick={(e) => {
            e.stopPropagation();
            setCurrentIndex((prev) => Math.max(0, prev - 1));
          }}
          aria-label="Previous media"
        >
          <FiChevronLeft size={18} />
        </button>
      )}

      {/* Floating Glass Next Chevron */}
      {currentIndex < media.length - 1 && (
        <button
          type="button"
          className="post-media-nav-btn post-media-nav-btn--next"
          onClick={(e) => {
            e.stopPropagation();
            setCurrentIndex((prev) => Math.min(media.length - 1, prev + 1));
          }}
          aria-label="Next media"
        >
          <FiChevronRight size={18} />
        </button>
      )}

      {/* Floating Bottom Pill Indicator Capsule */}
      <div className="post-media-dots-capsule">
        {media.map((_, dotIndex) => (
          <button
            key={dotIndex}
            type="button"
            className={`post-media-dot ${
              currentIndex === dotIndex ? "post-media-dot--active" : ""
            }`}
            onClick={(e) => {
              e.stopPropagation();
              setCurrentIndex(dotIndex);
            }}
            aria-label={`Go to slide ${dotIndex + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
